import React from 'react';

import { InfoGroup, RenderRichText } from '~/ui/components';
import { TicketOriginNames } from '~/typings/enums/Ticket/TicketOrigin';
import { LOAN_TYPE_NAMES } from '~/typings/enums/LoanType';
import { ServiceRecords } from '~/typings/entities/Ticket';
import { Content, DescriptionScroll, Wrapper } from './ServiceResume.styles';

type ServiceResumeProps = {
  service: ServiceRecords;
  product: string;
};

function ServiceResume({ service, product }: ServiceResumeProps) {
  return (
    <Wrapper>
      <Content>
        <InfoGroup label="Data de abertura" value={service?.createdAt} />
        <InfoGroup label="Criado por" value={service?.user?.name} />
        <InfoGroup label="Time" value={service?.team?.name} />
        <InfoGroup label="Origem do contato" value={TicketOriginNames[service?.contactOrigin]} />
        <InfoGroup label="Produto" value={LOAN_TYPE_NAMES[product]} />
      </Content>
      <InfoGroup
        label="Descrição"
        value={
          service?.description ? (
            <DescriptionScroll>
              <RenderRichText html={service?.description} />
            </DescriptionScroll>
          ) : (
            'Sem descrição'
          )
        }
      />
    </Wrapper>
  );
}

export default ServiceResume;
